// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { AgentStatusTurnFileCreateRequestedBuf } from '../conversation/agent-status-turn-file-create-requested-buf.js';
import { AgentStatusTurnFileCreateRespondedBuf } from '../conversation/agent-status-turn-file-create-responded-buf.js';
import { AgentStatusTurnFileEditRequestedBuf } from '../conversation/agent-status-turn-file-edit-requested-buf.js';
import { AgentStatusTurnFileEditRespondedBuf } from '../conversation/agent-status-turn-file-edit-responded-buf.js';
import { AgentStatusTurnFileLoadRequestedBuf } from '../conversation/agent-status-turn-file-load-requested-buf.js';
import { AgentStatusTurnFileLoadRespondedBuf } from '../conversation/agent-status-turn-file-load-responded-buf.js';
import { AgentStatusTurnFileMoveRequestedBuf } from '../conversation/agent-status-turn-file-move-requested-buf.js';
import { AgentStatusTurnFileMoveRespondedBuf } from '../conversation/agent-status-turn-file-move-responded-buf.js';
import { AgentStatusTurnFileUpdateRequestedBuf } from '../conversation/agent-status-turn-file-update-requested-buf.js';
import { AgentStatusTurnFileUpdateRespondedBuf } from '../conversation/agent-status-turn-file-update-responded-buf.js';


export class AgentStatusTurnPartBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):AgentStatusTurnPartBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsAgentStatusTurnPartBuf(bb:flatbuffers.ByteBuffer, obj?:AgentStatusTurnPartBuf):AgentStatusTurnPartBuf {
  return (obj || new AgentStatusTurnPartBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsAgentStatusTurnPartBuf(bb:flatbuffers.ByteBuffer, obj?:AgentStatusTurnPartBuf):AgentStatusTurnPartBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new AgentStatusTurnPartBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

fileLoadRequested(obj?:AgentStatusTurnFileLoadRequestedBuf):AgentStatusTurnFileLoadRequestedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new AgentStatusTurnFileLoadRequestedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileLoadResponded(obj?:AgentStatusTurnFileLoadRespondedBuf):AgentStatusTurnFileLoadRespondedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new AgentStatusTurnFileLoadRespondedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCreateRequested(obj?:AgentStatusTurnFileCreateRequestedBuf):AgentStatusTurnFileCreateRequestedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new AgentStatusTurnFileCreateRequestedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCreateResponded(obj?:AgentStatusTurnFileCreateRespondedBuf):AgentStatusTurnFileCreateRespondedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new AgentStatusTurnFileCreateRespondedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileMoveRequested(obj?:AgentStatusTurnFileMoveRequestedBuf):AgentStatusTurnFileMoveRequestedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new AgentStatusTurnFileMoveRequestedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileMoveResponded(obj?:AgentStatusTurnFileMoveRespondedBuf):AgentStatusTurnFileMoveRespondedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new AgentStatusTurnFileMoveRespondedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileUpdateRequested(obj?:AgentStatusTurnFileUpdateRequestedBuf):AgentStatusTurnFileUpdateRequestedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new AgentStatusTurnFileUpdateRequestedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileUpdateResponded(obj?:AgentStatusTurnFileUpdateRespondedBuf):AgentStatusTurnFileUpdateRespondedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new AgentStatusTurnFileUpdateRespondedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileEditRequested(obj?:AgentStatusTurnFileEditRequestedBuf):AgentStatusTurnFileEditRequestedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new AgentStatusTurnFileEditRequestedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileEditResponded(obj?:AgentStatusTurnFileEditRespondedBuf):AgentStatusTurnFileEditRespondedBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new AgentStatusTurnFileEditRespondedBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startAgentStatusTurnPartBuf(builder:flatbuffers.Builder) {
  builder.startObject(10);
}

static addFileLoadRequested(builder:flatbuffers.Builder, fileLoadRequestedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, fileLoadRequestedOffset, 0);
}

static addFileLoadResponded(builder:flatbuffers.Builder, fileLoadRespondedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, fileLoadRespondedOffset, 0);
}

static addFileCreateRequested(builder:flatbuffers.Builder, fileCreateRequestedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, fileCreateRequestedOffset, 0);
}

static addFileCreateResponded(builder:flatbuffers.Builder, fileCreateRespondedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, fileCreateRespondedOffset, 0);
}

static addFileMoveRequested(builder:flatbuffers.Builder, fileMoveRequestedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, fileMoveRequestedOffset, 0);
}

static addFileMoveResponded(builder:flatbuffers.Builder, fileMoveRespondedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, fileMoveRespondedOffset, 0);
}

static addFileUpdateRequested(builder:flatbuffers.Builder, fileUpdateRequestedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, fileUpdateRequestedOffset, 0);
}

static addFileUpdateResponded(builder:flatbuffers.Builder, fileUpdateRespondedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, fileUpdateRespondedOffset, 0);
}

static addFileEditRequested(builder:flatbuffers.Builder, fileEditRequestedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, fileEditRequestedOffset, 0);
}

static addFileEditResponded(builder:flatbuffers.Builder, fileEditRespondedOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, fileEditRespondedOffset, 0);
}

static endAgentStatusTurnPartBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
